import { chakra } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ComponentProps, ElementType } from 'react';

export const FaIcon = chakra(FontAwesomeIcon as unknown as ElementType, {
   baseStyle: {
      display: 'flex',
      alignItems: 'center',
   },
});

export type FaIconProps = ComponentProps<typeof FaIcon>;
